import { customFieldMediaSrc, parseCustomFieldMediaIds } from '@/lib/custom-field-display';
import { openAuthenticatedMedia } from '@/lib/authenticated-media';
import { mediaFileDisplayName } from './user-show-utils';

interface MediaFileMeta {
  id: string;
  title?: string | null;
  filename?: string | null;
}

interface MediaField {
  name: string;
  slug: string;
  value: unknown;
  rawValue?: string | null;
  mediaFiles?: MediaFileMeta[];
}

export function UserShowMediaField({ field }: { field: MediaField }) {
  const ids = parseCustomFieldMediaIds(field.value ?? field.rawValue);
  if (ids.length === 0) return null;

  const filesById = new Map((field.mediaFiles ?? []).map((file) => [file.id, file]));

  return (
    <div className="lms-user-show-photos">
      <div className="lms-user-show-photos__label">
        <span className="material-symbols-outlined" aria-hidden="true">
          badge
        </span>
        {field.name}
      </div>
      <div className={`lms-user-show-photos__row${ids.length > 1 ? ' lms-user-show-photos__row--split' : ''}`}>
        {ids.map((id) => {
          const src = customFieldMediaSrc(id);
          const label = mediaFileDisplayName(filesById.get(id));

          return (
            <div key={id} className="lms-user-show-photos__item">
              <div className="lms-user-show-photos__thumb" aria-hidden="true">
                <span className="material-symbols-outlined">image</span>
              </div>
              <span className="lms-user-show-photos__name" title={label}>
                {label}
              </span>
              <div className="lms-user-show-photos__actions">
                <button
                  type="button"
                  className="lms-user-show-photos__btn"
                  disabled={!src}
                  onClick={() => src && void openAuthenticatedMedia(src)}
                >
                  <span className="material-symbols-outlined" aria-hidden="true">
                    visibility
                  </span>
                  Ver
                </button>
                <button
                  type="button"
                  className="lms-user-show-photos__btn lms-user-show-photos__btn--icon"
                  disabled={!src}
                  aria-label={`Descargar ${label}`}
                  onClick={() => src && void openAuthenticatedMedia(src, label, true)}
                >
                  <span className="material-symbols-outlined" aria-hidden="true">
                    download
                  </span>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
